import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"

const IconNewspaper = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2" /><line x1="18" y1="2" x2="18" y2="22" /><line x1="10" y1="10" x2="14" y2="10" /><line x1="10" y1="14" x2="14" y2="14" />
  </svg>
)

const IconDownload = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
  </svg>
)

const NAV_ITEMS = [
  {
    to: "/NEWS",
    Icon: IconNewspaper,
    title: "News",
    desc: "Company updates, announcements & industry insights.",
    bg: "#eff6ff",
    ic: "#1b2d8e",
    features: [
      { label: "Company announcements" },
      { label: "Industry updates" },
      { label: "Team milestones" },
    ],
  },
  {
    to: "/WhitepapereBooks",
    Icon: IconDownload,
    title: "Downloads",
    desc: "White papers and eBooks on current technologies.",
    bg: "#f0fdf4",
    ic: "#16a34a",
    features: [
      { label: "Technical white papers" },
      { label: "Product eBooks" },
      { label: "Implementation guides" },
    ],
  },
]

const InformationHub = ({ queryData }) => (
  <div className="mega-menu">
    {/* Left: resource nav items */}
    <div className="mega-menu__left">
      <p className="mega-menu__section-label">Resources</p>
      {NAV_ITEMS.map(({ to, Icon, title, desc, bg, ic }) => (
        <Link key={to} to={to} className="mega-menu__nav-item">
          <div className="mega-menu__nav-icon" style={{ background: bg }}>
            <Icon style={{ color: ic }} />
          </div>
          <div className="mega-menu__nav-text">
            <strong>{title}</strong>
            <span>{desc}</span>
          </div>
        </Link>
      ))}
    </div>

    {/* Center: feature links grid */}
    <div className="mega-menu__center">
      <p className="mega-menu__section-label">What You'll Find</p>
      <div className="mega-menu__grid">
        {NAV_ITEMS.flatMap(({ to, features, bg, ic }) =>
          features.map(({ label }) => (
            <Link key={label} to={to} className="mega-menu__link">
              <div className="mega-menu__link-icon" style={{ background: bg, color: ic }}>→</div>
              {label}
            </Link>
          ))
        )}
      </div>
    </div>

    {/* Right: upcoming event */}
    <div className="mega-menu__right">
      <p className="mega-menu__section-label">Upcoming Event</p>
      <div className="mega-menu__featured-img">
        <Img fluid={queryData.learningcircle.childImageSharp.fluid} alt="Learning Circle" />
      </div>
      <p className="mega-menu__featured-desc">
        Learning Circle, an internal event to enhance employee knowledge &amp; skills.
      </p>
    </div>
  </div>
)

export default InformationHub
